import React, { useEffect, useState } from 'react';
import { Offcanvas, Tab, Nav } from 'react-bootstrap';
import { useLang } from "../../contexts/LanguageContext";
import fetchWithAuth from '../../api/fetchWithAuth';
import apiUrls from '../../api/apiUrls';
import './ChapterSettingsOffcanvas.css';

// Importar subcomponentes
import { AudioSettings } from './Settings/AudioSettings';
import { DictionarySettings } from './Settings/DictionarySettings';
import { TextSettings } from './Settings/TextSettings';
import { AmbientSettings } from './Settings/AmbientSettings';

const updatePreferences = async (newPreferences, bookLanguage) => {
  try {
    const response = await fetchWithAuth(apiUrls.apiUrlUpdatePreferences, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...newPreferences, bookLanguage }),
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.error || 'Error desconocido');
  } catch (err) {
    console.error('Error al actualizar las preferencias', err);
  }
};

function SettingsOffcanvas({ show, handleClose, onDialectChange, onFontSizeChange, onShowLemmaChange, onDictLanguageChange, onSpeedChange, onAutoPlayChange, preferences, bookLanguage }) {
  const { t } = useLang();

  const [localPreferences, setLocalPreferences] = useState({
    dialectCode: '',
    textSpeed: 1,
    autoPlay: false,
    dictLanguage: 'esp',
    showLemma: false,
    fontSize: 2,
    ambientTrackId: null,
    ambientVolume: 0.5
  });

  useEffect(() => {
    if (preferences) {
      setLocalPreferences({
        dialectCode: preferences.dialect_code || '',
        textSpeed: preferences.text_speed !== undefined ? preferences.text_speed : 2,
        autoPlay: preferences.auto_play === 1,
        dictLanguage: preferences.dict_language || 'esp',
        showLemma: preferences.show_IPA === 1,
        fontSize: preferences.font_size !== undefined ? preferences.font_size : 2,
        ambientTrackId: preferences.ambient_track_id || null,
        ambientVolume: preferences.ambient_volume !== undefined ? parseFloat(preferences.ambient_volume) : 0.5
      });
    }
  }, [preferences]);

  const handlePreferenceChange = async (key, value) => {
    const updatedPreferences = { ...localPreferences, [key]: value };
    setLocalPreferences(updatedPreferences);
    await updatePreferences(updatedPreferences, bookLanguage);
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton closeVariant="white">
        <Offcanvas.Title>{t("CHAPTER_SETTINGS_TITLE")}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="offcanvas-body">
        <Tab.Container defaultActiveKey="tab1">
          <form id="settings">
            <Nav variant="tabs">
              <Nav.Item><Nav.Link eventKey="tab1">{t("CHAPTER_SETTINGS_AUDIO")}</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="tab2">{t("CHAPTER_SETTINGS_DICTIONARY")}</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="tab3">{t("CHAPTER_SETTINGS_TEXT")}</Nav.Link></Nav.Item>
            </Nav>
            <Tab.Content className='settings-form'>
              <Tab.Pane eventKey="tab1">
                <AudioSettings 
                  preferences={localPreferences} 
                  onDialectChange={onDialectChange} 
                  onSpeedChange={onSpeedChange} 
                  onAutoPlayChange={onAutoPlayChange}
                  onChange={handlePreferenceChange} 
                />
                <AmbientSettings 
                  preferences={localPreferences} 
                  onChange={handlePreferenceChange} 
                />
              </Tab.Pane>
              <Tab.Pane eventKey="tab2">
                <DictionarySettings 
                  preferences={localPreferences} 
                  onDictLanguageChange={onDictLanguageChange}
                  onChange={handlePreferenceChange} 
                />
              </Tab.Pane>
              <Tab.Pane eventKey="tab3">
                <TextSettings 
                  preferences={localPreferences} 
                  onShowLemmaChange={onShowLemmaChange}
                  onFontSizeChange={onFontSizeChange}
                  onChange={handlePreferenceChange}
                />
              </Tab.Pane>
            </Tab.Content>
          </form>
        </Tab.Container>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SettingsOffcanvas;
